import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  managePartnerInvitation,
  ManagePartnerInvitationInput,
} from '@/features/partners/api/manage-partner-invitation';

type Props = Omit<
  UseMutationOptions<
    Awaited<ReturnType<typeof managePartnerInvitation>>,
    unknown,
    ManagePartnerInvitationInput
  >,
  'mutationFn'
>;

export const useManagePartnerInvitationMutation = ({ ...props }: Props) => {
  return useMutation({
    ...props,
    mutationFn: async (data) => {
      const { invitationToken, status } = data;
      return await managePartnerInvitation({ invitationToken, status });
    },
  });
};
